import { useState, useContext, useEffect, useCallback, Fragment } from "react";
import Numeral from "../../../components/numeral/Numeral";
import { useLocation, useNavigate } from "react-router-dom";
import { Primary } from "../../../components/buttons/Primary";
import { Fifth } from "../../../components/buttons/Fifth";
import { CreditUserContext } from "../../../context/CreditUser/CreditUserContext";
import { calcularFechas } from "../../../components/credits/calculoFechas";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { HttpRequest } from "../../../services/httpRequest";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { IndexedDBService } from "../../../services/indexedDbService";

const indexedDbService = new IndexedDBService();

export function ExtendPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state?.data;
  const { creditUser } = useContext(CreditUserContext);
  const { disclosures, creditInfo, due } = useCredit();
  const [countExtends, setCountExtends] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [idCredit, setIdCredit] = useState("");
  const [dateNew, setDateNew] = useState("");
  const [total, setTotal] = useState("0");
  const [costs, setCosts] = useState([]);

  const extendPermitidos = 3;

  const calcExtPlazo = (countExtends, extendPermitidos) => {
    let extendDisponibles = extendPermitidos - countExtends;
    if (extendDisponibles <= 0) {
      extendDisponibles = 0;
    }
    return extendDisponibles;
  };

  const loadCreditById = useCallback(async () => {
    try {
      const data = await HttpRequest.getCreditById(
        localStorage.getItem("credit_id")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadInfoQuota = useCallback(async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleUpdateDataIndexDb = useCallback(async (_total) => {
    try {
      let item = await indexedDbService.findItem('id', localStorage.getItem('credit_id'));
      if (item) {
        indexedDbService.updateItem(item.id, { amount: _total, hasExtend: true });
      } else {
        await indexedDbService.addItem({ amount: _total, id: localStorage.getItem('credit_id'), hasExtend: true });
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  const HandleSetCostsFeaturesAndTotalPay = useCallback(async (credit) => {
    try {
      let infoCupo = await loadInfoQuota();
      let versionTarifas = credit?.versionTarifas;
      let responseData = versionTarifas === "2" ? await HttpRequest.calcularDeudaV2({ credit: credit, infoCupo: infoCupo, }) :
        await HttpRequest.calcularDeuda({ credit: credit, infoCupo: infoCupo, });
      let infoDeudaBackend = responseData.message.deuda;
      let costsFeatures = infoDeudaBackend?.costsFeature;

      let costs = costsFeatures.filter(
        (feature) => feature?.item !== "Saldo a capital"
      );
      let total = 0;
      for (let i = 0; i < costs.length; i++) {
        let item = costs[i];
        if (item.item === "DCTO firma electrónica" || item.item === "DCTO recompensa") {
          total -= item.value;
        } else {
          total += costs[i].value;
        }
      }
      setCosts(costs);
      setTotal(total);
      handleUpdateDataIndexDb(total);
      return;
    } catch (error) {
      console.log(error);
      return [];
    }
  }, [loadInfoQuota, handleUpdateDataIndexDb]);

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          let creditUser = await loadCreditById(
            localStorage.getItem("credit_id")
          );
          await HandleSetCostsFeaturesAndTotalPay(creditUser);
          let fechas = calcularFechas();
          let dateNew = fechas.fecha2.format("DD/MM/YYYY");
          setDateNew(dateNew);
          setIdCredit(localStorage.getItem("credit_id"));
          let extendCount = calcExtPlazo(
            creditUser?.countExtends,
            extendPermitidos
          );
          setCountExtends(extendCount);
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, [navigate, loadCreditById, HandleSetCostsFeaturesAndTotalPay]);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"2"}
          title={"Novar crédito"}
          main={
            <>
              <div className="w-full h-full mt-10 rounded-3xl pb-32 md:pb-0 bg-white md:bg-transparent">
                <div className="sm:grid justify-center">
                  <div className="sm:w-120 w-full px-12 py-10 bg-white md:shadow-lg rounded-3xl">
                    <SkeletonDahsboard height={30} width={170} />
                    <div className="py-4">
                      <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                        <SkeletonDahsboard height={20} width={100} />
                        <SkeletonDahsboard height={20} width={70} />
                      </div>
                      <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                        <SkeletonDahsboard height={20} width={110} />
                        <SkeletonDahsboard height={20} width={50} />
                      </div>
                      <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                        <SkeletonDahsboard height={20} width={100} />
                        <SkeletonDahsboard height={20} width={60} />
                      </div>
                      <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                        <SkeletonDahsboard height={20} width={100} />
                        <SkeletonDahsboard height={20} width={60} />
                      </div>
                      <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                        <SkeletonDahsboard height={20} width={110} />
                        <SkeletonDahsboard height={20} width={50} />
                      </div>
                      <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                        <SkeletonDahsboard height={20} width={30} />
                        <SkeletonDahsboard height={20} width={55} />
                      </div>
                    </div>
                    <div>
                      <div className="flex gap-2 text-xl font-bold justify-between pt-4">
                        <SkeletonDahsboard height={30} width={130} />
                        <SkeletonDahsboard height={30} width={100} />
                      </div>
                    </div>
                    <div>
                      <SkeletonDahsboard height={20} width={200} />
                    </div>
                    <div className="flex gap-2 pt-8 sm:justify-center w-full">
                      <div className="pb-2 sm:pb-0 w-full">
                        <SkeletonDahsboard height={50} width={240} />
                      </div>
                      <div className="pb-2 sm:pb-0 w-full">
                        <SkeletonDahsboard height={50} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <DashboardMyCredit
      current={"2"}
      name={data?.name}
      balance={data?.amount}
      title={"Novar crédito"}
      disclosures={disclosures}
      creditInfo={creditInfo}
      due={due}
      main={
        <>
          {countExtends === 0 ? (
            <>
              <h3 className="pb-8">
                No tienes habilitada la opción de novaciones
              </h3>
              <div className="flex justify-center px-2 py-2">
                <img
                  width={450}
                  height={400}
                  src={require("./undraw_Warning_re_eoyh.png")}
                  alt=""
                ></img>
              </div>
            </>
          ) : (
            <div className="pb-10">
              <h3 className="px-4 md:px-0">
                La definición de novar crédito por el código civil consiste en
                sustituir un crédito por uno nuevo. Para que esto se pueda hacer
                efectivo en Galilea, debes pagar los cargos asociados a tu
                crédito a excepción del capital
              </h3>
              <div className="w-full h-full md:h-auto mt-10 rounded-3xl pb-32 md:pb-0 bg-white md:bg-transparent">
                <div className="sm:grid justify-center">
                  <div className="sm:w-120 w-full px-8 py-10 bg-white md:shadow-lg rounded-3xl">
                    <div className="flex justify-between">
                      <h3 className="font-bold text-xl">
                        Crédito N.{idCredit.substring(0, 8)}
                      </h3>
                    </div>
                    <div className=" py-4">
                      {costs.map((cost, i) => (
                        <div key={i} className="flex justify-between">
                          <span>{cost.value === 0 ? "" : cost.item} </span>
                          {
                            cost.item === "DCTO firma electrónica" && cost.value > 0 ? (
                              <span>{"-"}<Numeral format={"$0,0"} value={cost.value} /></span>
                            ) :
                              (
                                <span>{cost.item === "DCTO recompensa" ? "-" : ""}<Numeral format={"$0,0"} value={cost.value} /></span>
                              )
                          }
                        </div>
                      ))}
                    </div>
                    <div className="border-t-2 border-purple">
                      <div className="flex text-xl font-bold justify-between pt-4 ">
                        <span>Total a pagar</span>
                        <Numeral format={"$0,0"} value={total} />
                      </div>
                      <div className="flex justify-between">
                        <span>Nueva fecha límite de pago</span>
                        <span>{dateNew}</span>
                      </div>
                    </div>
                    <div className="flex gap-2 pt-6 justify-center">
                      <a href="/pagar">
                        <Fifth text={"Cancelar"} />
                      </a>
                      <a
                        href={"/medios-de-pago"}
                        className="pl-4"
                        replace={false}
                        state={{
                          data: {
                            isPaymentWompi: false,
                            credit_id: idCredit,
                            amount: data?.amount,
                            doc: creditUser?.documento,
                            name: data?.name,
                            extendPlazo: true,
                            dateExtend: dateNew,
                            totalSinCapital: total,
                          },
                        }}
                      >
                        <Primary
                          text={"Novar crédito"}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      }
    />
  );
}
